<script setup>
import { Link, Head } from '@inertiajs/vue3';

const links = [
    {
        name: 'Aanbod',
        href: '/portal/kavels',
        description: 'Bekijk alles wat mijn auto snel weg te bieden heeft hier.',
        icon: 'car',
    },
    // {
    //     name: 'Nieuws', href: '/portal/nieuws', description: 'Hier lees je het laatste automotive nieuws.', icon: NewspaperIcon,
    // },
]
</script>
<template>
    <Head title="Wegblokkade! | Mijnautosnelweg">
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
        <link rel="manifest" href="/site.webmanifest">
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ff5a22">
        <meta name="msapplication-TileColor" content="#ff5a22">
        <meta name="theme-color" content="#ffffff">
    </Head>
    <div class="bg-white">
        <main class="mx-auto w-full max-w-7xl px-6 pb-16 h-full pt-10 sm:pb-24 lg:px-8">
            <div class="mt-24 mx-auto max-w-2xl text-center">
                <p class="text-base font-semibold leading-8 text-royalblue-500">Wegblokkade!</p>
                <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Geen toegang tot deze weg.</h1>
                <p class="mt-6 text-base leading-7 text-gray-600">Je hebt niet voldoende rechten om de gekozen pagina te betreden.</p>
            </div>
            <div class="mx-auto mt-16 flow-root max-w-lg sm:mt-20">
                <h2 class="sr-only">Popular pages</h2>
                <ul role="list" class="-mt-6 divide-y divide-gray-900/5 border-b border-gray-900/5">
                    <li v-for="(link, linkIdx) in links" :key="linkIdx" class="relative flex gap-x-6 py-6">
                        <div
                            class="flex h-10 w-10 flex-none items-center justify-center rounded-lg shadow-sm ring-1 ring-gray-900/10">
                            <font-awesome-icon :icon="['far', link.icon]" class="h-6 w-6 text-royalblue-500 shrink-0" aria-hidden="true" />
                        </div>
                        <div class="flex-auto">
                            <h3 class="text-sm font-semibold leading-6 text-gray-900">
                                <Link :href="link.href">
                                <span class="absolute inset-0" aria-hidden="true" />
                                {{ link.name }}
                                </Link>
                            </h3>
                            <p class="mt-2 text-sm leading-6 text-gray-600">{{ link.description }}</p>
                        </div>
                        <div class="flex-none self-center">
                            <font-awesome-icon :icon="['fal', 'chevron-right']" class="h-5 w-5 text-gray-400 shrink-0" aria-hidden="true" />
                        </div>
                    </li>
                </ul>
                <div class="mt-10 flex justify-center">
                    <Link href="/portal/dashboard"
                        class="text-sm font-semibold leading-6 text-brightorange hover:text-brightorange/80">
                    <span aria-hidden="true">&larr;</span>
                    Terug naar dashboard
                    </Link>
                </div>
            </div>
        </main>
    </div>
</template>
